/* eslint-disable @typescript-eslint/naming-convention */
export interface TransferOutOptionsList {
	key: string;
	value: string;
	options: TransferOutOptions[];
}

export interface TransferOutOptions {
	key: string;
	value: string;
	isSelected: boolean;
}
